import { useNuxtApp, useRequestHeaders } from 'nuxt/app'
import { useAppStore } from '../stores/app'
import { COUNTRY_CODE_COOKIE_NAME, MY_COUNTRY_COOKIE_NAME, normalizeCountryCookieValue } from '../utils/countryContext'

export type RouteTarget = {
  readonly fullPath: string
}

const initCountryContextFromCookies = (appStore: ReturnType<typeof useAppStore>) => {
  const countryCodeFromCookie = normalizeCountryCookieValue(useAppCookie(COUNTRY_CODE_COOKIE_NAME).value)
  const myCountryFromCookie = normalizeCountryCookieValue(useAppCookie(MY_COUNTRY_COOKIE_NAME).value)
  // SWR 命中时 fallback 到 server middleware 已解析的 country-code 请求头。
  const countryCodeFromHeader = normalizeCountryCookieValue(useRequestHeaders(['country-code'])['country-code'])

  if (!appStore.CountryCode && (countryCodeFromCookie || countryCodeFromHeader)) {
    appStore.setCountryCode({ country: countryCodeFromCookie || countryCodeFromHeader })
  }

  if (!appStore.myCountry && myCountryFromCookie) {
    appStore.setMyCountry({ myCountry: myCountryFromCookie })
  }
}

export const initSharedAppHost = async (to: Readonly<RouteTarget>) => {
  const locale = useNuxtApp().$i18n.locale.value
  const hostHeader = useRequestHeaders(['host']).host
  const initialHost = hostHeader || (typeof window !== 'undefined' ? window.location.host : '')
  const host = initialHost.includes('aws.') ? initialHost.replace('aws.', '') : initialHost
  const appStore = useAppStore()

  appStore.setHostend(host)
  appStore.setAllhost(`https://${host}${to.fullPath}`)
  appStore.setPath(to.fullPath)
  appStore.setcookieHost(host.split(':')[0] ?? host)
  appStore.setLangCode({ lang: locale, hostS: host })
  initCountryContextFromCookies(appStore)
}
